import apiClient from './apiClient';
import { invalidateCalendarioRestriccionesCache } from './instancias.service';

const URL = process.env.REACT_APP_API_URL + "/restricciones/fechas-inicio-cursada";

export const getRestricciones = async () => {
    try {
        const response = await apiClient(`${URL}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        
        if(response.status !== 200) {
            throw new Error("Error al consultar restricciones");
        }
        const data = await response.json();
        return data
    } catch (error) {
        throw error
    }
}


export const putRestriccion = async (data) => {
    try {
       
        const response = await apiClient(`${URL}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        
        if(response.status !== 200) {
            throw new Error("Error al actualizar restricciones");
        }
        
        invalidateCalendarioRestriccionesCache();
        return true
    } catch (error) {
        throw error
    }
}
